import React from 'react'
import { Nav, Badge } from 'react-bootstrap'
import { Link } from 'react-router-dom';

const NavLink = ({
    to,
    children,
    active,
    badge
}) => {
    return (
        <Nav.Item>
            {badge && <Badge
                pill
                variant='danger'
                style={{
                    float: 'right',
                    marginBottom: '-10px',
                    marginRight: '40px',
                    zIndex: 100
                }}
            >
                &nbsp;
            </Badge>}
            <Nav.Link as={Link} to={to} eventKey={to} active={active}>{children}</Nav.Link>
        </Nav.Item>
    )
}

export default NavLink